module.exports = ":host ::ng-deep .quote-block content .row {\n  background-color: #310b17; }\n  :host ::ng-deep .quote-block content .row .pointer::after {\n    color: #310b17; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/containers/page-container/page-container.style.scss
// module id = 857
// module chunks = 2